exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".engine-key-metrics-view[data-v-78d73049] .main-stat .value{color:#e83030}.engine-key-metrics-view[data-v-78d73049] .simple-graph .path{stroke:#e83030}", ""]);
